var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M7 7.5v1a.5.5 0 0 1-1 0V8h-.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5zm7.5 6.5a.5.5 0 1 1 0 1h-13a.5.5 0 1 1 0-1H3v-3h1v3h8V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8H3l.002-8a2 2 0 0 1 2-2h5.996a2 2 0 0 1 2 2L13 14h1.5z" })
  );
});